import { useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import data from "../../data/IndustryLeaders.json";
import data1 from "../../data/IndustryLeaders1.json";
import ClientList from "../../data/overClients.json";
import { PopupContext } from "../../store/DemoForm-context";
import { SiteLogo } from "../../ui/SiteLogo";
import { Carousel } from "../share";
import styles from "./AboutNewPage.module.css";

const AboutNewPage = () => {
  const { showPopup } = useContext(PopupContext);
  const autoplayVideo = useRef(null);
  const playDegree = useRef(null);

  const autoPlayHand = (video) => {
    video.load();
    video.muted = true;
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then((_) => {
          video.play();
        })
        .catch((error) => {
          video.play();
        });
    }
  };
  const attemptPlay = () => {
    const video = autoplayVideo.current;
    video.load();
    video.muted = true;
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then((_) => {
          video.play();
        })
        .catch((error) => {
          video.play();
        });
    }
  };
  useEffect(() => {
    attemptPlay();
  }, []);
  return (
    <>
      <section className={`${styles.aboutSec} bg-primary`}>
        <div className="container">
          <div className={styles["hero-row"]}>
            <div className={styles["hero-content"]}>
              <h4>About Us</h4>
              <h2>
                We are <span>#1</span>
              </h2>
              <p>Live Video Commerce Product</p>
            </div>
            <div className={styles["hero-thumb"]}>
              <div className={styles["thumb-box"]}>
                <video ref={autoplayVideo} loop autoPlay={true} controls>
                  <source
                    src="/assets/video/hero-banner-v1.mp4"
                    type="video/mp4"
                  />
                  <p>Your browser does not support the video tag.</p>
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`${styles.aboutSec} bg-white`}>
        <div className="container">
          <div className={`${styles.secHeading}`}>
            <h3>Recognized by Industry Leaders</h3>
          </div>
          <Carousel data={data1} marginTop={false} />
          <Carousel data={data} direction={"rtl"} />
        </div>
      </section>
      <section className={`${styles.aboutSec} ${styles["bg-grey"]}`}>
        <div className="container">
          <div className={`${styles.secHeading}`}>
            <h3>Best Trust in Us</h3>
          </div>
          <Carousel data={ClientList} />
        </div>
      </section>
      <section className={`${styles.aboutSec} bg-white`}>
        <div className="container">
          <div className={styles.commerceVideoBox}>
            <div className={styles.videoTitle}>
              <h3>360 Degree Video Commerce Solution</h3>
            </div>
            <div className={styles.videoBox}>
              <video
                className="autoplay"
                ref={playDegree}
                loop
                autoPlay={true}
                controls
              >
                <source src="/assets/video/about-us-360.mp4" type="video/mp4" />
                <p>Your browser does not support the video tag.</p>
              </video>
            </div>
          </div>
        </div>
      </section>
      <section className={`${styles.aboutSec} bg-secondry`}>
        <div className="container">
          <div className={`${styles.secHeading} ${styles.headingTwo}`}>
            <h3>Number Says it all</h3>
          </div>
          <div className={styles.numberRow}>
            <div className={styles.numberCol}>
              <div className={styles.numberCard}>
                <figure>
                  <img src="/assets/images/videoSessions.png" />
                </figure>
                <h5>1 Million+</h5>
                <p>Video Engagement</p>
              </div>
            </div>
            <div className={styles.numberCol}>
              <div className={styles.numberCard}>
                <figure>
                  <img src="/assets/images/leadCapture.png" />
                </figure>
                <h5>2021</h5>
                <p>Founded</p>
              </div>
            </div>
            <div className={styles.numberCol}>
              <div className={styles.numberCard}>
                <figure>
                  <img src="/assets/images/engagement.png" />
                </figure>
                <h5>100+</h5>
                <p>Customers</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`${styles.aboutSec} bg-white`}>
        <div className="container">
          <div className={styles.aboutRow}>
            <div className={styles.aboutThumb}>
              <div className={styles.thumbBox}>
                <img src="/assets/images/about-thumb-1.png" />
                <div className={styles.logoBox}>
                  <SiteLogo varient="dark" />
                </div>
              </div>
            </div>
            <div className={styles.aboutText}>
              <h3>Our Mission</h3>
              <p>
                SaleAssist is dedicated to empowering businesses to create
                exceptional customer experiences and increase sale coversions
                through the power of live video commerce and accelerated by AI.
                By providing an innovative SaaS platform, we aim to
                revolutionize the way brands connect, engage, and convert
                customers. Our mission is to upgrade the traditional way of
                selling, enabling businesses to build lasting relationships,
                drive sales, and gain valuable customer insights. We strive to
                be the leading live video commerce solution, empowering our
                clients to achieve their full potential in the digital
                marketplace.
              </p>
            </div>
          </div>
          <div className={`${styles.aboutRow} ${styles.columnReverce}`}>
            <div className={styles.aboutThumb}>
              <div className={styles.thumbBox}>
                <img src="/assets/images/about-thumb-2.png" />
                <div className={styles.logoBox}>
                  <SiteLogo varient="dark" />
                </div>
              </div>
            </div>
            <div className={styles.aboutText}>
              <h3>Our Story</h3>
              <p>
                SaleAssist was born out of a shared passion for redefining the
                shopping experience. Having steered the helm of large-scale
                global e-commerce platforms, our founders witnessed firsthand
                the limitations of traditional online shopping. A deep-rooted
                desire to create more engaging, personalized, and interactive
                customer journeys led to the inception of SaleAssist.
              </p>
              <p>
                With a mission to bridge the gap between online and offline
                shopping, we developed a live video commerce platform that
                brings the in-store experience to the digital world. Backed by
                industry leaders and driven by a relentless pursuit of
                innovation, we've embarked on a journey to transform the way
                businesses connect with their customers.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={`${styles.aboutSec} bg-primary`}>
        <div className="container">
          <div className={`${styles.secHeading}`}>
            <h3>Our Leadership Team</h3>
          </div>
          <div className={styles.memberRow}>
            <div className={styles.memberCol}>
              <div className={styles.memberCard}>
                <div className={styles.memberThumb}>
                  <figure>
                    <img src="/assets/images/deep-malik.png" alt="deep mailk" />
                  </figure>
                </div>
                <div className={styles.memberCaption}>
                  <h4>Deep Malik</h4>
                  <p>CEO</p>
                  <div className={styles.linkedBtn}>
                    <Link
                      to={"https://www.linkedin.com/in/deep-malik-saleassist/"}
                      target="_blank"
                    >
                      <img
                        src="/assets/images/linkedinBtn.png"
                        alt="linkedin"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.memberCol}>
              <div className={styles.memberCard}>
                <div className={styles.memberThumb}>
                  <figure>
                    <img
                      src="/assets/images/chetan-jangir.png"
                      alt="chetan-jangir"
                    />
                  </figure>
                </div>
                <div className={styles.memberCaption}>
                  <h4>Chetan Jangir</h4>
                  <p>CTO & COO</p>
                  <div className={styles.linkedBtn}>
                    <Link
                      to={"https://www.linkedin.com/in/chetanjangir/"}
                      target="_blank"
                    >
                      <img
                        src="/assets/images/linkedinBtn.png"
                        alt="linkedin"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.memberCol}>
              <div className={styles.memberCard}>
                <div className={styles.memberThumb}>
                  <figure>
                    <img
                      src="/assets/images/satyam-srivastava.png"
                      alt="satyam-srivastava"
                    />
                  </figure>
                </div>
                <div className={styles.memberCaption}>
                  <h4>Satyam Srivastava</h4>
                  <p>Head of Engineering</p>
                  <div className={styles.linkedBtn}>
                    <Link
                      to={"https://www.linkedin.com/in/5atyam-5rivastava/"}
                      target="_blank"
                    >
                      <img
                        src="/assets/images/linkedinBtn.png"
                        alt="linkedin"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`${styles.aboutSec} ${styles["bg-grey"]}`}>
        <div className="container">
          <div className={styles.workRow}>
            <div className={styles.workThumb}>
              <figure>
                <img src="/assets/images/work-thumb.png" alt="work-thumb" />
              </figure>
            </div>
            <div className={styles.workContent}>
              <h6>Work at SaleAssist.ai</h6>
              <h3>People & Careers</h3>
              <p>
                At SaleAssist, we believe that our people are the cornerstone of
                our success. We are a dynamic team of passionate individuals who
                are driven by innovation and a shared vision of revolutionizing
                the way businesses interact with their customers.
              </p>
              <p>
                We offer a stimulating work environment where you can contribute
                to building a cutting-edge product that is transforming
                industries. Our culture fosters creativity, collaboration, and
                continuous learning. We are committed to providing our employees
                with opportunities for growth and development.
              </p>
              <p>
                If you are a talented and ambitious individual who is excited
                about the potential of live video commerce, we encourage you to
                explore career opportunities at SaleAssist. Join us in shaping
                the future of sales and customer engagement.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={`${styles.aboutSec} bg-white`}>
        <div className="container">
          <div className={`${styles.secHeading}`}>
            <h3>Join Hands - Become a Partner !</h3>
          </div>
          <div className={styles.partnerVideBox}>
            <div className={styles.videoBox}>
              <video
                muted
                width={1200}
                height={675}
                loop="loop"
                autoPlay="autoplay"
              >
                <source src="assets/video/partner-hero.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className={styles.videoContent}>
              <p>
                Ready to join the e-commerce revolution? Join our growing
                partner program to help your customers boost sales and
                engagement through the power of video commerce.
              </p>
              <button className="btn btn-primary btn-typ-1" onClick={showPopup}>
                <div>
                  <span>Become a Partner</span>
                  <span>Become a Partner</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutNewPage;
